module.exports = __webpack_public_path__ + "img/img_i-love-curitiba.2795ee47.jpg";